/**
 * Sets the number of days to display in the date strip
 */
export default Object.freeze({
  WEEK: 'week',
  FORTNIGHT: 'fortnight',
  MONTH: 'month',
  YEAR: 'year',
})
